import React, { Component } from "react"
import Slider from "react-slick"
import Recaptcha from "react-google-recaptcha"

import Link from "../utils/link"
import Play from "../assets/images/play.svg"
import Load from "../assets/images/load.png"
import { navigate } from "gatsby"

const RECAPTCHA_KEY = "6Lc_mi0iAAAAAPxvjkOBguy-Y9VKzHpmRV6HIGSi"

class Form extends Component {
  state = {
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  handleChange = (e) => {
    let { form } = this.state
    if (e.target.name === "type") {
      let current = form[e.target.name] || ""
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + " " + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(" " + e.target.value, "")
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleRecaptcha = (value) => {
    this.setState({ "g-recaptcha-response": value })
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    const formData = new FormData(this.form.current)
    formData.append("form-name", this.form.current.getAttribute("name"))
    const queryString = new URLSearchParams(formData).toString()

    // https://zapier.com/editor/204382722/published/204382723/sample
    await fetch(
      "https://hooks.zapier.com/hooks/catch/2181815/39qaqxa/?" + queryString
    )

    this.setState({ result: "success" })
  }

  render() {
    let props = {
      ref: this.form,
      name: "advocacy",
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === "success") {
      navigate("/thank-you-advocacy")
      return (
        <div className="signup__nav">
          <p>
            Thanks for getting in contact with us.
            <br /> A member of our team will be in touch soon.
          </p>
        </div>
      )
    }

    return (
      <div className="signup__nav">
        <p className="title">
          THE DEAL:
          <br />
          LOOKING TO BUY
        </p>
        <p>
          Looking for something? Find it here. We’ll get back to you shortly.
        </p>
        <form {...props}>
          <input type="hidden" name="source" value="advocacy_block" />
          <div className="signup__double">
            <input
              type="text"
              name="fname"
              placeholder="First Name"
              onChange={this.handleChange}
              required
            />
            <input
              type="text"
              name="lname"
              placeholder="Last Name"
              onChange={this.handleChange}
              required
            />
          </div>
          <div className="signup__double">
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={this.handleChange}
              required
            />
            <input
              type="text"
              name="phone"
              placeholder="Phone"
              onChange={this.handleChange}
              required
            />
          </div>
          <p>Currently Living?</p>
          <ul>
            <li>
              <input
                id={`checkbox_melbourne`}
                className="boxes"
                type="checkbox"
                name="checkbox_melbourne"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_melbourne`}>Melbourne</label>
            </li>
            <li>
              <input
                id={`checkbox_interstate`}
                className="boxes"
                type="checkbox"
                name="checkbox_interstate"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_interstate`}>Interstate</label>
            </li>
            <li>
              <input
                id={`checkbox_overseas`}
                className="boxes"
                type="checkbox"
                name="checkbox_overseas"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_overseas`}>Overseas</label>
            </li>
            <li>
              <input
                id={`checkbox_citizen`}
                className="boxes"
                type="checkbox"
                name="checkbox_australian_citizen"
                onChange={this.handleChange}
              />
              <label htmlFor={`checkbox_citizen`}>Australian Citizen</label>
            </li>
          </ul>
          <div className="recaptcha__wrapper">
            <Recaptcha
              ref="recaptcha"
              sitekey={RECAPTCHA_KEY}
              onChange={this.handleRecaptcha}
            />
          </div>
          <button className="contactbtn" type="submit">
            Submit
          </button>
          {this.state.result !== "" && (
            <p
              className="paragraph"
              dangerouslySetInnerHTML={{ __html: this.state.msg }}
            />
          )}
        </form>
      </div>
    )
  }
}

class AdvocacyBlock extends Component {
  state = {
    formActive: false,
    videoDesktopPlay: false,
    videoMobilePlay: false,
  }

  constructor(props) {
    super(props)
    this.props.items.forEach((el, i) => {
      this[`desktopVideos${i}`] = React.createRef()
      this[`mobileVideos${i}`] = React.createRef()
    })
  }

  _pauseAllVideos = () => {
    this.props.items.forEach((el, i) => {
      this[`desktopVideos${i}`]?.current?.pause()
      this[`mobileVideos${i}`]?.current?.pause()
    })
  }

  _toggleDesktopVideo = (index) => {
    if (!this.props.items[index].video) return
    const state = !this.state.videoDesktopPlay[index]
    this._pauseAllVideos()
    const video = this[`desktopVideos${index}`]?.current
    if (video) {
      state ? video.play() : video.pause()
    }
    this.setState({ videoDesktopPlay: { [index]: state } })
  }

  _toggleMobileVideo = (index) => {
    if (!this.props.items[index].video) return
    const state = !this.state.videoMobilePlay[index]
    this._pauseAllVideos()
    const video = this[`mobileVideos${index}`]?.current
    if (video) {
      state ? video.play() : video.pause()
    }
    this.setState({ videoMobilePlay: { [index]: state } })
  }

  openForm = () => {
    this.setState({ formActive: true })
  }

  getVideoID(url) {
    if (!url) return null
    let regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    let match = url.match(regExp)
    return match && match.length > 1 && match[1]
  }

  render() {
    const { logo, title, content, items, button } = this.props
    let { videoDesktopPlay, videoMobilePlay, formActive } = this.state

    let settings = {
      autoplay: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      beforeChange: this._pauseAllVideos,
    }

    return (
      <>
        <section className="advocacy-block" data-color="#FFFFFF">
          <div className="advocacy-block__inner container">
            {logo?.localFile && (
              <img
                className="logo"
                src={logo.localFile.publicURL}
                alt={logo?.altText}
              />
            )}
            {title && <h3 dangerouslySetInnerHTML={{ __html: title }} />}
            <div
              className="advocacy-block__content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <div className="advocacy-block__items advocacy-block__items--mobile">
              <Slider ref={(slider) => (this.slider = slider)} {...settings}>
                {items?.map((el, i) => (
                  <div className="advocacy-block__item" key={i}>
                    <picture
                      className={`${videoMobilePlay[i] ? "active" : ""}`}
                      onClick={() => this._toggleMobileVideo(i)}
                    >
                      <img
                        src={el.image?.localFile?.publicURL}
                        alt={el.title}
                      />
                      {(el.video || el.videoUrl) && (
                        <div className="video__play">
                          <span>Play</span>
                          <img src={Play} alt={"Whitefox - Play Video"} />
                        </div>
                      )}
                      {el.video?.publicUrl && !el.videoUrl && (
                        <video
                          src={el.video.publicUrl}
                          ref={this[`mobileVideos${i}`]}
                        />
                      )}
                      {el.videoUrl && (
                        <video
                          src={el.videoUrl}
                          ref={this[`mobileVideos${i}`]}
                        />
                      )}
                    </picture>
                    <h4>{el.title}</h4>
                    <div
                      className="advocacy-block__item-content"
                      dangerouslySetInnerHTML={{ __html: el.content }}
                    />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="advocacy-block__items advocacy-block__items--desktop">
              {items?.map((el, i) => (
                <div className="advocacy-block__item" key={i}>
                  <picture
                    className={`${videoDesktopPlay[i] ? "active" : ""}`}
                    onClick={() => this._toggleDesktopVideo(i)}
                  >
                    <img src={el.image?.localFile?.publicURL} alt={el.title} />
                    {(el.video || el.videoUrl ) && (
                      <div className="video__play">
                        <span>Play</span>
                        <img src={Play} alt={"Whitefox - Play Video"} />
                      </div>
                    )}
                    {el.video?.publicUrl && !el.videoUrl && (
                      <video
                        src={el.video.publicUrl}
                        ref={this[`desktopVideos${i}`]}
                      />
                    )}
                    {el.videoUrl && (
                      <video
                        src={el.videoUrl}
                        ref={this[`desktopVideos${i}`]}
                      />
                    )}
                  </picture>
                  <h4>{el.title}</h4>
                  <div
                    className="advocacy-block__item-content"
                    dangerouslySetInnerHTML={{ __html: el.content }}
                  />
                </div>
              ))}
            </div>
            {button.text && (
              <Link
                to={button.link}
                className="advocacy-block__button"
                onClick={!button.link && this.openForm}
              >
                {button.text}
              </Link>
            )}
          </div>
        </section>
        <div className={`signup ${formActive ? "active" : ""}`}>
          <Form />
          <div className="signup__close">
            <button
              className={formActive ? "active" : ""}
              onClick={() => this.setState({ formActive: false })}
            >
              <img src={Load} alt="Close sign up form" />
            </button>
          </div>
        </div>
      </>
    )
  }
}

export default AdvocacyBlock
